var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RessourceInfoBulle',{attrs:{"code":"DE-TITRE"}}),_c('RessourceInfoBulle',{attrs:{"code":"DE-SOUS-TITRE"}}),_c('RessourceInfoBulle',{attrs:{"code":"DE-TEXTE"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }